export const BASE_URL = "https://admin.unjiz.com/apis";
export const clientKey = "unjiz777";
export const currency = "SAR";
